import { render, staticRenderFns } from "./KiraBilgileriList.vue?vue&type=template&id=38aa55f8"
import script from "./KiraBilgileriList.vue?vue&type=script&lang=ts"
export * from "./KiraBilgileriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports